import styled from "styled-components";
import Button from "../../Button";
import useDetectOutsideClick from "../../../../hooks/useDetectOutsideClick";
import { useRef } from "react";
import React from "react";

const Container = styled.div<{
  $shouldShow: boolean;
  $hasActionButton: boolean;
  $menuItemAmount: number;

  $position?: { top: string };
}>`
  position: absolute;
  right: 0px;
  top: ${({ $position }) => $position?.top};

  z-index: 1;

  height: ${({ $shouldShow }) => ($shouldShow ? "auto" : "0px")};
  width: 230px;
  padding: 8px;

  visibility: ${({ $shouldShow }) => ($shouldShow ? "visible" : "hidden")};

  border: 1px solid var(--color-dark-blue-300);
  border-radius: 8px;

  transition: height 0.3s ease-in-out;

  display: flex;
  flex-direction: column;

  background: var(--color-light-0);

  .actions {
    position: relative;

    height: ${({ $hasActionButton }) =>
      $hasActionButton ? "calc(100% - 40px)" : "calc(100% - 10px)"};

    overflow: auto;
  }

  .actions button {
    font-family: var(--font-paragraph-default);
    color: var(--color-text-paragraph);
    font-size: 14px;

    margin: 0;
    padding: 12px;
    width: 100%;

    border-radius: 8px;

    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    svg {
      color: var(--color-text-labels);
      width: 16px !important;
      height: 16px !important;
    }
  }
`;

const MenuItem = styled.div<{ $isTooltipVisible?: boolean }>`
  display: flex;

  align-items: center;

  width: 100%;

  border-radius: 8px;
`;

type TImportFileMenuProps = {
  shouldShowMenu: boolean;
  onClickAway: () => void;
  position?: { top: string };
  onAction?: { text: string; callback: () => void };
  children: React.ReactNode;
};

const ImportFileMenu: React.FC<TImportFileMenuProps> = ({
  shouldShowMenu,
  onClickAway,
  position,
  onAction,
  children,
}) => {
  const menuRef = useRef<HTMLDivElement | null>(null);

  const childrenArray = React.Children.toArray(children);

  useDetectOutsideClick({
    isClicked: shouldShowMenu,
    componentRef: menuRef,
    onOutside() {
      onClickAway();
    },
  });

  return (
    <Container
      $position={position}
      $hasActionButton={!!onAction}
      ref={menuRef}
      $shouldShow={shouldShowMenu}
      $menuItemAmount={childrenArray.length}
    >
      <div className="actions">
        {childrenArray.map((child, idx) => (
          <MenuItem key={idx}>{child}</MenuItem>
        ))}
      </div>
      {onAction && (
        <Button
          variant="outline"
          icon="link"
          iconPosition="left"
          text={onAction.text}
          onClick={onAction.callback}
        />
      )}
    </Container>
  );
};

export default ImportFileMenu;
